import { API_URL } from "./Config";
import { formatDate } from "./DateUtils";
import { IDetailsResponse } from "./IDetailsResponse";
import { GetLicenseDetailsAsync, ILicenceDetails } from "./LicenceDetails";

export interface IEpaCorrespondenceDetails extends IDetailsResponse {
  epainitiatedcorrespondenceid: string;
  type: string;
  reference: string;
  subject: string;
  status: string;
  datesubmitted: string;
  duedate: string;
  licensingnotification: string;
  correspondencetype: string;
  licenseesubmissionid?: string;
  licenceid: string;
  licenceprofileid: string;
  licenceDetails?: ILicenceDetails;
}

export async function GetEpaCorrespondenceDetailsAsync(
  epaCorrespondenceId: string
): Promise<IEpaCorrespondenceDetails> {
  var url = `${API_URL}/MeetingCorrespondence/epainiciatedcorrespondencebyid?epainitiatedcorrespondence_id=${epaCorrespondenceId}`;

  if (process.env.REACT_APP_EPA_ENV === "localhost") {
    url = `${API_URL}/epa-correspondence-details`;
  }

  var response = await fetch(url);
  var body = <IEpaCorrespondenceDetails>await response.json();

  body.licenceDetails = await GetLicenseDetailsAsync(body.licenceid);

  return <IEpaCorrespondenceDetails>{
    response: response,
    epainitiatedcorrespondenceid: body.epainitiatedcorrespondenceid,
    type: body.type,
    reference: body.reference,
    subject: body.subject,
    status: body.status,
    datesubmitted: formatDate(body.datesubmitted),
    duedate: formatDate(body.duedate),
    licensingnotification: body.licensingnotification,
    correspondencetype: body.correspondencetype,
    licenceid: body.licenceid,
    licenceprofileid: body.licenceprofileid,
    licenceDetails: body.licenceDetails,
  };
}
